import cc from 'classcat';

import { flattenResponsiveHeroImage } from '../../lib/contentful/selectors';
import { ResponsiveImage } from '../../components/ResponsiveImage';

import styles from './styles.module.scss';

/**
 * A responsive hero image intended to be used in composable contentful stacks.
 * This image is intended to be a background image and will always be rendered
 * outside of the normal flow of content within it's own stack, so that it
 * can be easily positioned absolutely as a background image without disrupting
 * the flow of the other elements.
 *
 * @param {object} props - The props!
 * @param {object} props.desktopBackground - The desktop background image from
 *   contentful.
 * @param {object} props.mobileBackground - The mobile background image from
 *   contentful.
 * @param {string} props.className - The class name to apply to the container.
 * @returns {JSX.Element}
 */
function ResponsiveHeroImage({
  desktopBackground,
  mobileBackground,
  className,
}) {
  const desktopImage = flattenResponsiveHeroImage(desktopBackground);
  const mobileImage = flattenResponsiveHeroImage(mobileBackground);

  return (
    <ResponsiveImage
      images={{ desktopImage, mobileImage }}
      classNames={{
        container: cc([styles.container, className]),
        desktopImage: styles.background,
        mobileImage: styles.background,
      }}
    />
  );
}

export default ResponsiveHeroImage;
